import { createContext, useContext } from "react";
import type { Dispatch, SetStateAction } from "react";

import type { UseMutationConfig, Disposable } from "react-relay";

import type { LogoutMutation } from "pianofunclub-shared/relay/graphql/auth/__generated__/LogoutMutation.graphql";
import type { MeQuery$data } from "pianofunclub-shared/relay/graphql/general/__generated__/MeQuery.graphql";

export type AuthState = {
  accountType: string | null;
  userToken: string | null;
};

export type AuthAction =
  | {
      accountType?: string | null;
      token: string | null;
      type: "ADD_TOKEN";
    }
  | { type: "REMOVE_TOKEN" };

export interface AuthContextType {
  authState: AuthState;
  clientSideLogout: () => void;
  dispatchAuthState: Dispatch<AuthAction>;
  logout: (variables: {
    commitLogout: (config: UseMutationConfig<LogoutMutation>) => Disposable;
    onCompleted?: () => void;
    resetRelayEnvironment: () => void;
  }) => void;
  setUser: Dispatch<SetStateAction<MeQuery$data["me"] | null>>;
  user: MeQuery$data["me"] | null;
}

export const AuthContext = createContext<AuthContextType | null>(null);

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
};
